
import styles from "./navbar.module.css"
import  "./navbar.css"
import pdf from "../body/Rahul Y H_Resume.pdf"
import { useEffect, useState } from "react"


function Navbar(){

    /*Home
About
Skills
Projects
Contact
Resume



*/



const [dis,setDis]=useState("none")
const [t,setT]=useState(false)

const [width,setWidth]=useState(window.innerWidth)



const styles1={
   display: t ? "grid" : "none",
   borderRadius:"none",

}

useEffect(()=>{

  

    function handleResize() {
      console.log('resized to: ', window.innerWidth, 'x', window.innerHeight)
      setT(false)
  }



  window.addEventListener("resize",handleResize)

  
},[])





function display(){
 
  console.log(window.innerWidth)


  

  
 
setT(!t);
  
   
}


function handleResume(){
  window.open(`https://drive.google.com/file/d/1W2DmkFvCEetMLkmDoZ4dsxni9dAa_nqw/view?usp=share_link`,"_blank")
      }
    return (
        <>
        <div className={styles.navbar} id="nav-menu" >
             <div className={styles.nav2}>
              

                <h2 className="nav-h2-rahul" >Rahul Y H </h2>
                
                </div>

             <div className={styles.nav1} id="nav1" >
             
               <p>
               <a href="#home1" id="home"  >Home</a>
               </p>
               <p>
               <a href="#about1" id="about" className="about section" >About</a>
               </p>
              <p>
               <a href="#skills1" id="skills" >Skills</a>
               </p>
               <p>
               <a href="#projects11" id="projects" >Projects</a>
               </p>
               <p>
               <a href="#contact1" id="contact" >Contact</a>
               </p>


    
      <p>
      <a href={pdf} target="_blank" rel="noreferrer"  download  onClick={handleResume} id="resume-button-1">
  Resume
</a>
      
             
        
               </p>
               
              
 
             </div>


             <div className="n123" onClick={display} style={{border:"0px solid black"}}>
           
                  <img className="i123" width="50%" src="https://cdn-icons-png.flaticon.com/512/148/148795.png" alt="menu"  />
             </div>
        </div>


<div className="nav1" id="nav111" style={styles1} >


<p>
               <a href="#home1" id="home" >Home</a>
               </p>
               <p>
               <a href="#about1" id="about" className="about section" >About</a>
               </p>
               <p>
               <a href="#skills1" id="skills" >Skills</a>
               </p>
               <p>
               <a href="#projects1" id="projects" >Projects</a>
               </p>
               <p>
               <a href="#contact1" id="contact" >Contact</a>
               </p>


    
      <p>
      <a href={pdf} target="_blank" rel="noreferrer"  download  onClick={handleResume} id="resume-button-1">
  Resume
</a>
       </p>
</div> 
        

    



        </>
    )
}

export default Navbar